export type FilterTypeValueType = 'string' | 'bool' | 'array' | 'number' | 'date';

export interface FilterOption {
  operators: string[];
  operatorsTranslationPrefix?: string;
  values: string[];
  valuesTranslationPrefix?: string;
  defaultOperator: string;
  defaultValue: string;
  filterType: FilterTypeValueType;
}

export const OPERATORS_TRANSLATION_PREFIX_DEFAULT = 'segmentationRules.conditions';
export const VALUES_TRANSLATION_PREFIX_DEFAULT = 'segmentationRules.values';

export function instanceOfFilterOption(object: object): object is FilterOption {
  return 'operators' in object && 'values' in object && 'defaultOperator' in object && 'defaultValue' in object;
}

export type SegmentationOption = {
  [key: string]: SegmentationOption | FilterOption;
};

export function instanceOfSegmentationOption(object: object): object is SegmentationOption {
  const keys = Object.keys(object);
  let isType = true;
  keys.forEach(key => {
    isType = isType && (instanceOfFilterOption(object[key]) || instanceOfSegmentationOption(object[key]));
  });
  return isType;
}
